<template>
  <Transition name="slide-fade">
    <nav v-show="showMobileMenu" class="mobile-menu">
      <div class="mobile-menu__head">
        <div class="mobile-menu__head-control">
          <v-btn 
            @click="toggleMobileMenu"
            class="mobile-menu__menu-switcher"
            variant="text"
            title="Menu mobile">
              <v-icon v-if="!showMobileMenu" size="35">mdi-menu</v-icon>
              <v-icon v-else size="35">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="mobile-menu__functions">
          <ContrastSwitcher></ContrastSwitcher>
          <FontsizeSwitcher></FontsizeSwitcher>
          <LanguageSwitcher />
        </div>
      </div>
      <div class="mobile-menu__breaker"></div>
      <div class="mobile-menu__content">
        <MainLinks />
        <div class="mobile-menu__breaker"></div>
        <ArticleList />
      </div>
    </nav>
  </Transition>
</template>

<script lang="ts">
import { computed, defineComponent, Ref } from 'vue';
import store                              from '@/store';
import ArticleList from './ArticleList.vue';
import ContrastSwitcher from './ContrastSwitcher.vue';
import FontsizeSwitcher from './FontsizeSwitcher.vue';
import LanguageSwitcher from './LanguageSwitcher.vue';
import MainLinks from './MainLinks.vue';

const MobileMenu: object = defineComponent({
  components: {
    ContrastSwitcher,
    FontsizeSwitcher,
    LanguageSwitcher,
    ArticleList,
    MainLinks,
  },
  setup() {
    const showMobileMenu: Ref<boolean> = computed((): boolean => store.state.showMobileMenu);
    const toggleMobileMenu = () => {
      store.commit('toggleMobileMenu');
    };
 
    return {
      showMobileMenu,
      toggleMobileMenu,
    };
  },
});
export default MobileMenu;
</script>

<style scoped lang="scss">
.mobile-menu {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 80%;
  max-width: 280px;
  height: 100%;
  color: $main-font-color;
  background-color:$main-bg-color;
  box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.3);
  z-index: 100;
  padding: 12px;
  text-align: center;

  &__head {
    &-control {
      display: flex;
      justify-content: flex-end;
    }
  }

  &__functions {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  &__content {
   display: flex;
   flex-direction: column;
   align-items: center;
   overflow-y: auto;
   height: 53vh;
  }

  &__breaker {
    height: 2px;
    width: 90%;
    background-color: $yellow-static;
    margin: 10px auto;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

</style>
